import { S as Swiper } from './swiper-core-BXF75Fx2.js';
import { N as Navigation } from './navigation-BvT7k6pb.js';
import { P as Pagination } from './pagination-z4kt-BHd.js';
import { A as Autoplay } from './autoplay-CsPtyn3v.js';
import './create-element-if-not-defined-BFxMbgz9.js';

class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  /**
   * Get navigation configuration for swiper
   * @returns {Object|boolean} Navigation configuration or false
   */
  getNavigationConfig() {
    const showNavigation = this.dataset.showNavigation === 'true';

    if (!showNavigation) return false;

    const nextElement = this.querySelector('.swiper-button-next');
    const prevElement = this.querySelector('.swiper-button-prev');

    return {
      nextEl: nextElement,
      prevEl: prevElement,
      disabledClass: 'swiper-button-disabled',
    };
  }

  /**
   * Get pagination configuration for swiper
   * @param {HTMLElement} swiperEl - The swiper container element
   * @returns {Object|boolean} Pagination configuration or false
   */
  getPaginationConfig(swiperEl) {
    const showPagination = this.dataset.showPagination === 'true';

    if (!showPagination) return false;

    return {
      el: swiperEl ? swiperEl.querySelector('.swiper-pagination') : null,
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    };
  }

  getAutoplayConfig() {
    const autoplay = this.dataset.autoplay === 'true';
    const delay = parseInt(this.dataset.autoplayDelay) * 1000 || 5000;
    const disableOnHover = this.dataset.autoplayDisableOnHover === 'true';

    if (!autoplay) return false;

    return { delay, pauseOnMouseEnter: disableOnHover };
  }

  /**
   * Initialize the swiper instance
   */
  initSwiper() {
    const swiperEl = this.querySelector('.swiper--featured');
    if (!swiperEl) {
      console.warn('Featured Collection: Swiper element not found');
      return;
    }

    // Get settings from data attributes
    const loop = this.dataset.loop === 'true';
    const navigation = this.getNavigationConfig(swiperEl);
    const pagination = this.getPaginationConfig(swiperEl);
    const autoplay = this.getAutoplayConfig();

    const swiperOptions = {
      modules: [Navigation, Pagination, Autoplay],
      spaceBetween: 16,
      slidesPerView: 1.3,
      loop,
      watchOverflow: true,
      pagination,
      navigation,
      autoplay,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3.2,
        },
        1140: {
          slidesPerView: 4.1,
        },
      },
    };

    // Initialize swiper
    const swiperInstance = new Swiper(swiperEl, swiperOptions);

    // Don't run autoplay on tabs that aren't the active one
    if (autoplay && this.getAttribute('aria-hidden') === 'true') {
      swiperInstance.autoplay.stop();
    }

    // Store reference for potential external access
    this.swiper = swiperInstance;
  }

  /**
   * Destroy swiper instance when element is disconnected
   */
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-collection', FeaturedCollection);
